import React, { useState } from 'react';

import { renderPageContent } from '../../../lib/ContentRenderer';

import { CardItem, MultiSwitch } from '../../../components';
import { useSiteQuery } from '../../../hooks';
import ErrorPage from '../../_error';

import query from './index.graphql';

import styles from './index.module.scss';

const filterItems: Array<MultiSwitchItem> = [
  { title: 'All News & Events', value: '' },
  { title: 'News', value: 'articles_news_Entry' },
  { title: 'Events', value: 'articles_event_Entry' },
];

const renderPageEntry = (entry: PageEntryContentFragment) => (
  <>
    {entry.hero?.[0] && (
      <div className="sectionWrapper">
        <div className="pageBanner">
          <div className="container">
            <h1>{entry.hero[0].customTitle}</h1>
            <p>{entry.hero[0].headline}</p>
          </div>
        </div>
      </div>
    )}
    {entry.pageContent?.map((row) => renderPageContent(row!, false, entry))}
  </>
);

const NewsAndEvents = () => {
  const [activeFilter, setActiveFilter] = useState('');
  const [{ data, error }] = useSiteQuery<NewsEventsQuery>({ query });

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  const entry = data?.entry;
  const articles = data?.articles;
  const filtered = articles?.filter((item) => !activeFilter || (activeFilter && item?.__typename === activeFilter));
  return (
    <div className={styles.articles}>
      {entry?.__typename === 'pages_pages_Entry' && renderPageEntry(entry)}
      <div className="section">
        <div className="container">
          <div className={styles.multiSwitchContainer}>
            <MultiSwitch
              items={filterItems}
              defaultActiveItem={filterItems?.[0]}
              onClick={(item: MultiSwitchItem) => item && setActiveFilter(item?.value as string)}
            />
          </div>
          <div className="row cardsWrapper">
            {filtered?.map((item) => item && <CardItem key={item.uid!} item={item} />)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsAndEvents;
